import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import useSound from "use-sound";
import "./App.css";

import pornsound from "./pornsound.mp3";
import buttonImg from "./button.png";
import trollfaceImg from "./trollface.png";

const App = () => {
  const [pressed, setPressed] = useState(false);
  const [play] = useSound(pornsound);
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    setPressed(true);
    play();
    document.title = "I Love Feet Pics"; // Embarrassing title change
  };

  const handleShare = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Hide message after 2 seconds
    });
  };

  // Prevent leaving & play sound again
  useEffect(() => {
    if (pressed) {
      const warnUser = (event) => {
        event.preventDefault();
        play(); // Play the sound again
        event.returnValue = "You sure you want to leave? 😈"; // Show exit warning
      };

      window.addEventListener("beforeunload", warnUser);
      return () => window.removeEventListener("beforeunload", warnUser);
    }
  }, [pressed, play]);

  return (
    <div className="container">
      {!pressed ? (
        <img 
          src={buttonImg} 
          alt="Do Not Press" 
          className="button" 
          onClick={handleClick} 
        />
      ) : (
        <div className="trolled">
          <motion.img
            src={trollfaceImg}
            alt="Trollface"
            className="trollface"
            initial={{ scale: 0, rotate: 0 }}
            animate={{ scale: 1.5, rotate: 360 }}
            transition={{ duration: 0.8 }}
          />
          <div className="share-container">
            <button className="share-btn" onClick={handleShare}>
              Share with Friends 😈
            </button>
            {copied && <p className="copied-msg">Link copied! Send it to your friends 😈</p>}
          </div>
        </div>
      )}
    </div>
  );
};

export default App;
